import { render, staticRenderFns } from "./CoverageCategory.vue?vue&type=template&id=a94a37f2&scoped=true"
import script from "./CoverageCategory.vue?vue&type=script&lang=js"
export * from "./CoverageCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94a37f2",
  null
  
)

export default component.exports